import React from 'react';

import currencyFormatter from 'currency-formatter';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Button } from '@mui/material';

interface GiftCardCart {
  items: unknown[];
  amounts: {
    grandTotal: number;
  };
  currencyCode: string;
}

interface Props {
  backStep: () => void;
  proceedStep: () => void;
  nextStepLabel: string;
  cart: GiftCardCart;
  canProceed: boolean;
}

function GiftCardOrderFooter({ backStep, proceedStep, nextStepLabel, cart, canProceed }: Props) {
  const { items, amounts, currencyCode } = cart;

  return (
    <div className="new-order-footer">
      <Button variant="text" className="back-section" onClick={backStep}>
        <ArrowBackIcon fontSize="small" style={{ marginRight: '5px' }} />
        <span className="text">Back</span>
      </Button>
      <div className="main-section">
        <div className="meta">
          <div className="offer-title">Gift card order</div>
        </div>

        <div className="amounts">
          <div className="amount">
            <div className="noun">Gift Cards</div>
            <div className="value data-hj-whitelist">{items.length}</div>
          </div>
          <div className="amount">
            <div className="noun">Total</div>
            <div className="value data-hj-whitelist">
              {currencyCode}{' '}
              {currencyFormatter.format(amounts.grandTotal, {
                code: currencyCode,
              })}
            </div>
          </div>
        </div>

        <div className="action">
          <Button className="T-proceed-step-btn" variant="contained" onClick={proceedStep} disabled={!canProceed}>
            {nextStepLabel} <ArrowForwardIosIcon fontSize="small" />
          </Button>
        </div>
      </div>
    </div>
  );
}

export default GiftCardOrderFooter;
